import PropTypes from 'prop-types';

export const blogPostPT = PropTypes.shape({
  active: PropTypes.bool,
  author: PropTypes.shape({
    id: PropTypes.string,
    full_name: PropTypes.string,
    uri_param: PropTypes.string,
    avatar: PropTypes.string,
    about: PropTypes.string,
  }),
  blog_author_id: PropTypes.string,
  body: PropTypes.string,
  category: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
  }),
  category_id: PropTypes.string,
  category_type: PropTypes.string,
  created_at: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  is_listed: PropTypes.bool,
  meta_description: PropTypes.string,
  picture: PropTypes.string,
  preview_link: PropTypes.string,
  published_at: PropTypes.string,
  related_articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      uri_param: PropTypes.string,
      picture: PropTypes.string,
      published_at: PropTypes.string,
    })
  ),
  seo_title: PropTypes.string,
  title: PropTypes.string,
  updated_at: PropTypes.string,
  uri_param: PropTypes.string,
});

export const blogPostCategoriesPT = PropTypes.exact({
  created_at: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  store_id: PropTypes.string,
  updated_at: PropTypes.string,
});
